import moment from 'moment'
import { GpsDataType } from '@/app/constants/gpsDataType'
import type { GpsDataModel } from '@/app/models/gpsDataModel'
import type { GpsFromTachographModel } from '@/app/models/gpsFromTachographModel'

export type BorderEntry = GpsFromTachographModel & {
  isManual?: boolean
  city?: string
}

export function createBorderEntries({
  gpsData,
  tachographData,
  dateFrom,
  dateTo,
}: {
  gpsData: GpsDataModel[]
  tachographData: GpsFromTachographModel[]
  dateFrom: string
  dateTo: string
}): BorderEntry[] {
  const from = moment(dateFrom).startOf('day')
  const until = moment(dateTo).startOf('day').add(1, 'day')
  const entries: BorderEntry[] = tachographData.map((item, index) => ({
    ...item,
    id: `tachograph-${item.id ?? index}`,
    checked: false,
  }))

  for (const item of gpsData) {
    if (item.type !== GpsDataType.BorderCrossing) continue

    // Imported GPS describes a stay in a country, not a single crossing.
    // Keep both ends, including rows with only one known timestamp.
    for (const isArrival of [false, true]) {
      const date = isArrival ? item.arriveDate : item.leaveDate
      if (!date) continue
      entries.push({
        id: `gps-${item.id}-${isArrival ? 'arrival' : 'departure'}`,
        date: moment(date),
        country: item.foreignCountry,
        city: item.city || '',
        isArrival,
        isTransit: item.transit,
        checked: false,
      })
    }
  }

  return entries
    .filter((item) => item.date?.isValid() && item.date.isSameOrAfter(from) && item.date.isBefore(until))
    .sort((a, b) => a.date.valueOf() - b.date.valueOf() || Number(a.isArrival) - Number(b.isArrival))
}
